// removed by extract-text-webpack-plugin
module.exports = {"Image":"rB8ApoSduFT5LzdCcFEa7"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Button/style.css
// module id = 1326
// module chunks = 0